"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataStats = void 0;
var DataStats = /** @class */ (function () {
    function DataStats(label, value) {
        this.label = label;
        this.value = value;
    }
    return DataStats;
}());
exports.DataStats = DataStats;
